import { auth, Timestamp } from './modules/firebase.js';

import gameInfo from './public/gameInfo.json'
import {setNewUserName, signIn, 
    getUserInfo, updateGameInfo, getPenguinSkins, updateUserLoginTime, getAllUsersLeaderBoard,
    updateLeaderboardUserData, getOtherSkins, getLists, updateLogs, getPrivateData, updateResetBlueberries,
    checkBirthdayReward, timeSinceLastPlay, activateBirthdayReward, setFriends,trigger_ClaimDailyReward,
    signIn_EmailPassword,
    create_EmailPassword,
    forgotPassword,
    setLetters} from './modules/account.js'
import { addLoading, removeLoading, setLoadingText } from './modules/loading.js';
import { loadGameSkins } from './modules/imageCache.js';
import { checkUserAgreement } from './modules/termsPolicy.js';
import { isEmailVerified } from './modules/emailVerified.js';

let storageCounter = 0

// ACCOUNT
let signedIn = false
let newPlayer = false
let userData;
let userGameData;
let userPublic;
let privateUser;
let dailyReward;
let user;
let list = [];

// FISH
let fishCounter = 0;
let samonCount = 0
let secondCounter = 0
let syncCounter = 0
let maxSyncCounter = 45

let fishChance = 1
let fishMaxCounter = 2000
let fishClickMultiplier = 0

// UpgradeRewards
let clickRewardMultiplier = 0
let multiplyRewardMultiplier = 1

// GameVariables
let upgradePriceIncrease = 1.3

// Boost
let boost = 0;
let boostCounter = 0;
let maxBoost = 5;

// VARIABLES
let gameData = {}
let upgradeData = []
let upgradeRewardTypes = {}
let upgrades;

// SIMULATED CLICK
let clickSpeed = 20
let clickCounter = 0
let skinsData;
let gameSkins;

let leaderBoard;

// DEV
let dev = false
let p = ""
let scounter = 100

// PASSWORD FOR ALL YOU PROGRAMMERS OUT THERE, ITS RIGHT HERE
const password = "t3st3r"
const betaMode = false

let attempts = 0;
const maxAttempts = 5;

let showTutorial = false

let privateGame;

function Tutorial(step){
    let stepHTML = ''
    if(step == 1){
        let Price = shortenNumber(Math.round(oldGetPrice(0)))
        let PPS = shortenNumber(upgradeData[0].pps)
        let imageName = upgradeData[0].type
        const image = gameSkins[imageName]
        stepHTML = `
        <div class="popup" id="tutorialStep" style="visibility: visible;">
            <div class="popupBox" id="tutorialStepBox">
                <span class='tutorialInstructions tutorialInstructionsHeader'>You can now get penguins passively!</span>
                    <div class="upgrade">
                        <img draggable="false" src="${image}" class="upgradeImg">
                        <div class="upgradeDetails">
                            <h3 class="upgradeName">${upgradeData[0].name}</h3>
                            <h2 class="upgradePrice" id="${0}Price">${Price}</h2>
                        </div>
                        <p class="upgradeText">PPS + ${PPS}</p>
                        <div class="progressBar">
                            <div class="progress"></div>
                            <div class="progressPenguinCoinBox">
                                <img class="progressPenguinCoinImage" src="/images/elements/penguinCoin.png">
                            </div>
                        </div>
                        <span class="upgradeAmount">${upgrades[0].amount} x</span>
                    </div>
                    <span class='tutorialInstructions'>This upgrade will give you 1 PPS <br> (Penguin Per Second)</span>
                    <span class='tutorialInstructions'>Find this upgrade and click it!</span>
                <button class="btn closePopup" style="margin-top: 10px; background-color:  rgb(100, 100, 100);">CLOSE</button>
            </div>
        </div>`
    }
    if(step == 2){
        let Price = shortenNumber(Math.round(oldGetPrice(1)))
        let PPS = shortenNumber(upgradeData[1].pps)
        let imageName = upgradeData[1].type
        const image = gameSkins[imageName]
        stepHTML = `
        <div class="popup" id="tutorialStep" style="visibility: visible;">
            <div class="popupBox" id="tutorialStepBox">
                <span class='tutorialInstructions tutorialInstructionsHeader'>Keep Going!</span>
                    <div class="upgrade">
                        <img draggable="false" src="${image}" class="upgradeImg">
                        <div class="upgradeDetails">
                            <h3 class="upgradeName">${upgradeData[1].name}</h3>
                            <h2 class="upgradePrice" id="${1}Price">${Price}</h2>
                        </div>
                        <p class="upgradeText">PPS + ${PPS}</p>
                        <div class="progressBar"><div class="progress"></div></div>
                        <span class="upgradeAmount">${upgrades[1].amount} x</span>
                    </div>
                    <span class='tutorialInstructions'>Each time you unlock a penguin you get a new one with a better PPS!</span>
                    <span class='tutorialInstructions'>Save up for this penguin!</span>
                <button class="btn closePopup" style="margin-top: 10px; background-color:  rgb(100, 100, 100);">CLOSE</button>
            </div>
        </div>`
    }
    if(step == 3){
        const progressWidth = String(upgrades[1].progress*10)+"%"
        stepHTML = `
        <div class="popup" id="tutorialStep" style="visibility: visible;">
            <div class="popupBox" id="tutorialStepBox">
                <span class='tutorialInstructions tutorialInstructionsHeader'>Level up!</span>
                    <div class="upgrade">
                        <div class="progressBar"><div class="progress" style="width:${progressWidth}"></div></div>
                    </div>
                    <span class='tutorialInstructions'>Level up the bar on each penguin to get a Penguin Coins. <br><br> Spend the Penguin Coins to roll for rewards!</span>
                    <button class="iconBox" style="background-color: transparent; border: 0; margin: auto;">
                        <img class="iconImage" src="./images/elements/menu.png">
                    </button>
                    <span class='tutorialInstructions'>Visit the Reward Shop to see rewards</span>
                <button class="btn closePopup" style="margin-top: 10px; background-color:  rgb(100, 100, 100);">CLOSE</button>
            </div>
        </div>`
    }
    document.body.insertAdjacentHTML('beforeend', stepHTML)
    setPopupHiding()
}

function addPenguin(shownPenguins){
    let cleanedShownPenguins = shortenNumber(shownPenguins)
    let penguinNumber = document.getElementById("penguinNumber")
    penguinNumber.innerHTML = cleanedShownPenguins
    if(gameData.resets == 0 && gameData.penguinPerSecond == 0 && gameData.penguins >= upgradeData[0].price && !showTutorial){
        showTutorial = true
        Tutorial(1)
    }
}

function PenguinClicked(event){
    let amount = 1
    if (clickRewardMultiplier != 0 || fishClickMultiplier != 0){
        amount = fishClickMultiplier + clickRewardMultiplier
    }
    addClickNumberElement(amount, event, "black")
    gameData.penguins += fishClickMultiplier + clickRewardMultiplier + 1
    let shownPenguins = Math.round(gameData.penguins)
    addPenguin(shownPenguins)
}

function checkForNewUpgrade(upgradeIndex){

    const nextUpgradeIndex = upgradeIndex+1
    const nextUpgrade = upgradeData[nextUpgradeIndex]

    if (nextUpgradeIndex == 1 && newPlayer){
        if( document.getElementById("clickNotification")){
            document.getElementById("clickNotification").remove()
        }
    }

    // IF THERE IS ANOTHER UPGRADE ADD TO UPGRADES AND THE ONE JUST CLICKED WAS LOCKED
    if (nextUpgrade && upgrades[upgradeIndex].locked){

        upgrades.push({
            amount: 0,
            upgrade: 0,
            progress: 0,
            locked: true,
        })

        gameData.upgradeRewards[upgradeIndex] = 
        {
            "amount": 0,
        }

        addNewUpgradeElement(nextUpgradeIndex)
        if(signedIn){
            const logText = {
                unlock: nextUpgradeIndex
            }
            updateLogs('gameProgress', logText, 'penguinClicker')
        }
    }

    //IF THE ONE JUST CLICKED WAS LOCKED
    if(upgrades[upgradeIndex].locked){
        if(signedIn){
            if(!privateGame.otherSkins.includes(gameData.currentImg)){
                gameData.currentImg = upgradeData[upgradeIndex].type;
                setMainImage()
            }
        }else{
            gameData.currentImg = upgradeData[upgradeIndex].type;
            setMainImage()
        }
        
        addResetPrompt(!nextUpgrade)
        upgrades[upgradeIndex].locked = false
    }

    if(!nextUpgrade && signedIn){
        addResetOption()
    }
}

function oldGetPrice(upgradeIndex){ 
    let Price = 0
    let p = upgradeData[upgradeIndex].price
    let a = upgrades[upgradeIndex].amount+1
    let m = 3.5
    let d = 0.5

    const tempPrice = (p * Math.pow(a, (m)) / a * d)
    Price = tempPrice + ((tempPrice * (upgrades[upgradeIndex].upgrade))*.2)
    
    if(upgrades[upgradeIndex].amount == 0){
        return(upgradeData[upgradeIndex].price)
    }else{
        return (Price)
    }
}   

async function oldCalculatePPS(){
    gameData.penguinPerSecond = 0

    for (const upgradeIndex in upgrades){
        gameData.penguinPerSecond += (upgrades[upgradeIndex].amount * upgradeData[upgradeIndex].pps)/100
    }

    // SETTING PENGUIN UPGRADE PPS
    const shownPPS = (gameData.penguinPerSecond*100).toFixed(0)

    let penguinPerSecondElement = document.getElementById("penguinsPerSecond")
    penguinPerSecondElement.innerHTML = String("PPS: "+ shownPPS)

    //await FIREBASE_updateUser(gameData.playerID, gameData.penguinPerSecond, shownPPS, gameData.resets)
}

function createCoin(startPosition) {
    // Get starting and ending positions
    const endPosition = document.getElementById('penguinCoins').getBoundingClientRect();

    // Create a new coin element
    const newCoin = document.createElement('img');
    newCoin.src = '/images/elements/penguinCoin.png';
    newCoin.classList.add('coinElement');
    document.body.appendChild(newCoin);

    // Ensure the element is positioned absolutely
    newCoin.style.position = 'fixed';

    // Set the initial position of the coin
    newCoin.style.left = `${startPosition.left}px`;
    newCoin.style.top = `${startPosition.top}px`;

    // Delay to start animation after styles are applied
    setTimeout(() => {
        // Animate to the target position
        newCoin.style.left = `${endPosition.left}px`;
        newCoin.style.top = `${endPosition.top}px`;

        // Remove the element after animation ends
        setTimeout(() => {
            newCoin.remove();
            document.getElementById('penguinCoins').classList.add('penguinCoinsAnimation')
            setTimeout(() => {
                document.getElementById('penguinCoins').classList.remove('penguinCoinsAnimation')
                showUpgradePoints()
            },500);
        }, 1000); // Matches the transition duration
    }, 500);
}

function upgradeActivated(upgradeIndex, giftedPenguin){

    upgradeIndex = parseInt(upgradeIndex)

    let upgrade = upgrades[upgradeIndex]
    let Price = oldGetPrice(upgradeIndex)

    if(!giftedPenguin){
        gameData.penguins -= Price;
    }

    upgrade.amount += 1
    upgrade.progress += 1

    // SETTING PENGUIN UPGRADE PRICE
    let shownPrice = shortenNumber(Math.round(oldGetPrice(upgradeIndex)))

    let PriceElement = document.getElementById(upgradeIndex+"Price")
    PriceElement.innerHTML = shownPrice

    let AmountElement = document.getElementById(upgradeIndex+"Amount")
    AmountElement.innerHTML = upgrade.amount + ' x'

    let ProgressElement = document.getElementById(upgradeIndex+"Progress")

    if (upgrade.progress == 10){
        ProgressElement.style.width = "0%"

        // Setting Variables
        upgrade.progress = 0
        gameData.upgradePoints += 1
        upgrade.upgrade += 1

        if(!signedIn){
            setLocalStorage()
        }
        const startPosition = document.getElementById(upgradeIndex + "ProgressCoin").getBoundingClientRect();
        createCoin(startPosition)
    }
    else{
        ProgressElement.style.width = String(upgrade.progress*10)+"%"
    }

    oldCalculatePPS()
    checkForNewUpgrade(upgradeIndex)

    if(gameData.resets == 0 && upgradeIndex == 0 && upgrade.amount == 1){
        Tutorial(2)
    }

    if(gameData.resets == 0 && upgradeIndex == 1 && upgrade.amount == 1){
        Tutorial(3)
    }

    // UPGRADE HAPPENS
}

function upgradeClicked(upgradeIndex){

    let Price = oldGetPrice(upgradeIndex)

    if (gameData.penguins >= Price){
        upgradeActivated(upgradeIndex, false)
    }
}

function checkForUnlocks(){
    for (const upgradeIndex in upgrades){
        let Price = oldGetPrice(upgradeIndex)
        if(gameData.penguins >= Price){
            let upgradeElement = document.getElementById(upgradeIndex)
            upgradeElement.classList.remove("locked")
        }
        else if(gameData.penguins < Price){
            let upgradeElement = document.getElementById(upgradeIndex)
            upgradeElement.classList.add("locked")
        }
    }
}

function addNewUpgradeElement(upgradeIndex){
    let upgradesElement = document.getElementById("upgrades")
    let Price = shortenNumber(Math.round(oldGetPrice(upgradeIndex)))
    let PPS = shortenNumber(upgradeData[upgradeIndex].pps)
    let imageName = upgradeData[upgradeIndex].type
    const image = gameSkins[imageName]
    let upgradeElement = `
    <div class="upgrade locked" id="${upgradeIndex}">
        <img draggable="false" src="${image}" class="upgradeImg">
        <div class="upgradeDetails">
            <h3 class="upgradeName">${upgradeData[upgradeIndex].name}</h3>
            <h2 class="upgradePrice" id="${upgradeIndex}Price">${Price}</h2>
        </div>
        <p class="upgradeText" id="${upgradeIndex}PPS" >PPS + ${PPS}</p>
        <div class="progressBar">
            <div class="progress" id="${upgradeIndex}Progress"></div>
            <div class="progressPenguinCoinBox" id="${upgradeIndex}ProgressCoin">
                <img class="progressPenguinCoinImage" src="/images/elements/penguinCoin.png">
            </div>
        </div>
        <span class="upgradeAmount" id="${upgradeIndex}Amount">${upgrades[upgradeIndex].amount} x</span>
    </div>`
    upgradesElement.insertAdjacentHTML("beforeend",upgradeElement)

    let ProgressElement = document.getElementById(upgradeIndex+"Progress")
    ProgressElement.style.width = String(upgrades[upgradeIndex].progress*10)+"%"
}

function addResetOption(){
    let resetPrompt = document.getElementById('resetPrompt')
    if(resetPrompt){
        resetPrompt.remove()
    }

    let resetOption = document.getElementById('resetOption')
    if(!resetOption){
        const  upgradesElement = document.getElementById("upgrades")
        const  upgradeElement = `
        <div class="upgradeReset" id="resetOption">
            <img draggable="false" src="./images/elements/blueBerry.png" class="upgradeImg">
            <div class="upgradeDetails">
                <h3 class="upgradeName">LEVEL UP!</h3>
            </div>
            <p class="upgradeText">+200 Blueberries</p>
            <span class="upgradeAmount" style="grid-row: 3/4; grid-column: 1/4;">Blueberries can be spent in shop!</span>
        </div>`
        upgradesElement.insertAdjacentHTML("beforeend",upgradeElement)
        resetOption = document.getElementById('resetOption')
        resetOption.addEventListener('click',()=>{
            RESETPOPUP()
        })
    }
}

function addResetPrompt(ready){
    let resetPrompt = document.getElementById('resetPrompt')
    if(resetPrompt){
        resetPrompt.remove()
    }
    let titleText = "UNLOCK ALL TO LEVEL UP!";
    if(ready){
        titleText = "LOGIN TO LEVEL UP!"
    }
    let helpText = "Blueberries can be spent in shop!"
    if(!signedIn){
        helpText = 'Login to Level Up and collect Blueberries!'
    }
    const  upgradesElement = document.getElementById("upgrades")
    const  upgradeElement = `
    <div class="upgradeReset disabledReset" id="resetPrompt">
        <img draggable="false" src="./images/elements/blueBerry.png" class="upgradeImg">
        <div class="upgradeDetails">
            <h3 class="upgradeName">${titleText}</h3>
        </div>
        <p class="upgradeText">+200 Blueberries</p>
        <span class="upgradeAmount" style="grid-row: 3/4; grid-column: 1/4; text-align: left;">${helpText}</span>
    </div>`
    upgradesElement.insertAdjacentHTML("beforeend",upgradeElement)
}

function RESETPOPUP(){
    document.getElementById('ResetPopup').style.visibility = 'visible'
    document.getElementById('resetActivate').addEventListener('click',()=>{
        document.getElementById('resetActivate').disabled = true;
        RESET()
    },{ once: true })
    // document.getElementById('resetShop').addEventListener('click',()=>{
    //     TravelToUpgradeShop()
    // })
}

let canReset = true;
async function RESET(){
    addLoading()
    if(canReset && upgrades.length == upgradeData.length && !upgrades[upgrades.length-1].locked && signedIn){
        canReset = false
        const result = await updateResetBlueberries();
        if(result){
            const resets = gameData.resets + 1
            const oldEquippedSkin = gameData.currentImg

            let penguinPass;
            if(gameData.penguinPass){
                penguinPass = JSON.parse(JSON.stringify(gameData.penguinPass));
            }

            let premiumPass;
            if(gameData.premiumPass){
                premiumPass = JSON.parse(JSON.stringify(gameData.premiumPass));
            }

            // let upgradeRewards;
            // if(gameData.upgradeRewards){
            //     upgradeRewards = JSON.parse(JSON.stringify(gameData.upgradeRewards));
            // }

            gameData = gameInfo.gameData
            upgrades = [{
                amount: 0,
                upgrade: 0,
                progress: 0,
                locked: true,
            }]

            if(penguinPass){
                gameData['penguinPass'] = penguinPass
            }

            if(premiumPass){
                gameData['premiumPass'] = premiumPass
            }

            // if(upgradeRewards){
            //     gameData['upgradeRewards'] = upgradeRewards
            // }

            gameData.currentImg = oldEquippedSkin
            gameData.resets = resets
        
            await syncData(true);
            await updateLogs('reset', 'user reset progress', 'penguinClicker')
        
            window.location = 'game.html';
        }else{
            alert('There was an error resetting!')
            removeLoading()
            document.getElementById('resetActivate').disabled = false;
        }
    }
}

// FISH

function fishSpawning(){
    if (fishCounter == fishMaxCounter){
        fishCounter = 0;
        let randInt = getRandomInt(1,10)
        if(randInt <= fishChance){
            randInt = getRandomInt(1,10)
            if (randInt <= 3){
                addFish("krill")
            }
            else if (randInt <= 6){
                addFish("squid")
            }
            else if(randInt <= 9){
                addFish("salmon")
            }
            else if (randInt == 10){
                addFish("goldFish")
            }
        }
    }
}

function addFish(fishType){

    const yOffset = getRandomInt(10,200)
    const penguinImageBox = document.getElementById("penguinImageBox").getBoundingClientRect()
    const fishElement = document.createElement("img");
    fishElement.classList.add("fishImage");
    fishElement.src = p+`/images/fish/${fishType}.png`
    fishElement.style.top = (yOffset+'px')
    fishElement.style.left = (penguinImageBox.right+'px')
    fishElement.id = fishType

    document.body.appendChild(fishElement);

    setTimeout(()=>{
        if(fishElement){
            fishElement.remove();
        }
    }, 5900) 
}

function krill(event){
    let newPenguins = Math.round(gameData.penguinPerSecond * 100 * 100)
    addClickNumberElement(newPenguins, event, "rgb(255, 187, 0)")

    document.getElementById("penguinNumber").classList.add("penguinNumberIncrease")

    // WHEN KRILL IS CLICKED

    setTimeout(()=>{
        document.getElementById("penguinNumber").classList.remove("penguinNumberIncrease")
        gameData.penguins += newPenguins
        syncData(true)
    }, 900)

    event.target.remove();
}

function addClickNumberElement(amount, event, color){
    const numberElement = document.createElement("div");
    numberElement.innerHTML = amount
    numberElement.style.top = (event.clientY +"px")
    numberElement.style.left = (event.clientX+"px")
    numberElement.style.position = "fixed"
    numberElement.style.pointerEvents = "none"

    numberElement.style.color = color;

    document.body.appendChild(numberElement);
    numberElement.classList.add("NumberSpawn")

    setTimeout(()=>{
        numberElement.remove()
    }, 900)
}

function addClickNotification(){
    const notification = `<h3 id="clickNotification">CLICK!</h3>`
    document.getElementById("penguinImageBox").insertAdjacentHTML("beforebegin",notification)
}

function salmon(event){
    event.target.remove();
    samonCount += 1

    addClickNotification()

    if(gameData.penguinPerSecond*100 >= 1){
        fishClickMultiplier = Math.round(gameData.penguinPerSecond*100) * 2 * samonCount
    }
    else{
        fishClickMultiplier = 2 * samonCount
    }

    setTimeout(()=>{
        document.getElementById("clickNotification").remove()
        samonCount -= 1
        if (samonCount <= 0){
            fishClickMultiplier = 0
            syncData(true)
        }
        // WHEN SALMON FISH ENDS
    }, 10000) 
}

function goldFish(event){
    // Getting Upgrade
    gameData.upgradePoints += 1
    createCoin({left: event.clientX, top: event.clientY})
    if(!signedIn){
        setLocalStorage()
    }else{
        // WHEN GOLD FISH REWARDED
        syncData(false)
    }
    event.target.remove();
}

function squid(event){
    boost += .1
    event.target.remove();
    updateBoost()
    addClickNumberElement("BOOST +0.1", event, "cornflowerblue")
}

function fishClicked(event){
    const fishID = event.target.id

    if (fishID == "salmon"){
        salmon(event)
    }
    else if (fishID == "krill"){
        krill(event)
    }
    else if (fishID == "squid"){
        squid(event)
    }
    else if (fishID == "goldFish"){
        goldFish(event)
    }
}

function convertTimestampToDate(timestamp) {
    if (timestamp instanceof Timestamp) {
        // Convert Firebase Timestamp to JavaScript Date
        return timestamp.toDate();
    } else if (typeof timestamp === 'object' && timestamp.seconds) {
        // Handle if it's an object with 'seconds' field
        return new Date(timestamp.seconds * 1000);
    } else {
        // If it's a string or already a Date object
        return new Date(timestamp);
    }
}

function updateOfflineUpgrades(){
    const diffTime = calculateTimePassed(gameData.Date);
    const removedUpgrades = []
    let totalUpgradesPenguins = 0;
    for (const activeupgrade in gameData.activeUpgrades){
        const activeUpgradeData = upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name];
        let elapsedTime = gameData.activeUpgrades[activeupgrade].timeElapsed;
        if(gameData.activeUpgrades[activeupgrade].type != "penguin"){
            if(activeUpgradeData.runOffline && elapsedTime > 0){
                const duration = activeUpgradeData.duration;
                const remainingTime = duration - elapsedTime
                // if more time has passed then was left
                if(diffTime > remainingTime){
                    addOfflineUpgrades(activeUpgradeData, remainingTime)
                    removedUpgrades.push(activeupgrade)
                }
        
                // less time has passed then what was left
                else{
                    addOfflineUpgrades(activeUpgradeData, diffTime)
                    gameData.activeUpgrades[activeupgrade].timeElapsed = Math.round(elapsedTime += diffTime)
                }
            }else if(elapsedTime == 0){
                gameData.activeUpgrades[activeupgrade].timeElapsed = 1
            }
        }
    }

    for(const activeupgrade of removedUpgrades){
        gameData.activeUpgrades.splice(activeupgrade,1);
    }

    function addOfflineUpgrades(activeUpgradeData,time){
        if(activeUpgradeData.type == "multiply"){
            const addedPenguins = gameData.penguinPerSecond * activeUpgradeData.multiply * time * 100;
            totalUpgradesPenguins += addedPenguins;
            gameData.penguins += addedPenguins;
        }
    
        else if(activeUpgradeData.type == "click"){
            const tempClickRewardMultiplier = Math.ceil(((gameData.penguinPerSecond*100) / activeUpgradeData.clickPercentage));
            const addedPenguins = tempClickRewardMultiplier * time * 10;
            totalUpgradesPenguins += addedPenguins;
            gameData.penguins += addedPenguins;
        }
    }
    return totalUpgradesPenguins
}

function calculateTimePassed(date) {
    const oldData = convertTimestampToDate(date); // Parse the saved timestamp
    const now = new Date(); // Get the current time

    // Calculate the difference in seconds
    const diffTimeInSeconds = (now - oldData) / 1000;

    return diffTimeInSeconds; // Return time in seconds
}

function getTimePassed() {
    const diffTime = calculateTimePassed(gameData.Date); // Get time passed in seconds
    const totalUpgradesPenguins = updateOfflineUpgrades()

    // Calculate new penguins based on penguinPerSecond (adjusted for seconds)
    let newPenguins = diffTime * gameData.penguinPerSecond * 100;

    if (newPenguins) {
        gameData.penguins += newPenguins; // Update penguin count
    }else{
        newPenguins = 0
    }

    if(totalUpgradesPenguins != 0 ){
        document.getElementById("newPenguinsText").innerHTML = shortenNumber(Math.round(totalUpgradesPenguins))
        document.getElementById("welcomeBack").style.visibility = "visible";
    }

    // FIX THIS
    syncData(true)
}

function mainLoop(){
    const newPenguinsMult = gameData.penguinPerSecond * multiplyRewardMultiplier
    const newPenguins = newPenguinsMult + (newPenguinsMult * boost)
    gameData.penguins += newPenguins;
    
    let shownPenguins = Math.round(gameData.penguins)

    if(clickRewardMultiplier != 0 && clickSpeed == clickCounter){
        var penguinImageBox = document.getElementById('penguinImageBox')
        var img = penguinImageBox.getBoundingClientRect();

        var centerX = img.left + (img.width / 2);
        var centerY = img.top + (img.height / 2);

        var event = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true,
            'clientX': centerX,  // X coordinate
            'clientY': centerY   // Y coordinate
        });

        penguinImageBox.dispatchEvent(event)

        if (clickRewardMultiplier != 0 || fishClickMultiplier != 0){
            addClickNumberElement(fishClickMultiplier + clickRewardMultiplier, event, "rgb(255, 187, 0)")
        }

        gameData.penguins += fishClickMultiplier + clickRewardMultiplier + 1

        clickCounter = 0
    }

    clickCounter += 1;

    addPenguin(shownPenguins)

    checkForUnlocks()

    fishCounter += 1
    storageCounter += 1
    secondCounter += 1
    boostCounter += 1

    fishSpawning()

    if (storageCounter == scounter){
        if(!signedIn){
            setLocalStorage()
        }
        storageCounter = 0
    }

    if(secondCounter == 100){
        updateActiveUpgrades()
        secondCounter = 0
        if(signedIn){
            syncCounter += 1
            if(syncCounter == maxSyncCounter){
                syncCounter = 0;
                syncData(false)
                setSaveTimerText()
            }
            setSaveTimer()
        }
    }

    if(boostCounter >= 1000){
        if(boost < maxBoost-.01){
            boost += .01;
            boostCounter = 0;
            updateBoost()
        }

    }
}

function updateBoost(){
    document.getElementById("boostAmount").innerHTML = boost.toFixed(2) + "X BOOST"
    document.getElementById("boostInnerBar").style.width = (boost/maxBoost)*100 + "%"
}

function setSaveTimerText(){
    const countdownInternalText= document.getElementById('countdownInternalText')
    countdownInternalText.innerHTML = "DATA <br> SAVED!"
    countdownInternalText.style.backgroundColor = "cornflowerblue"
    setTimeout(()=>{
        countdownInternalText.innerHTML = "AUTO <br> SAVE"
        countdownInternalText.style.backgroundColor = "#C9C9C9"
    },1000)
}

function setSaveTimer(){
    const circlePercentage = String((((syncCounter)*190)/maxSyncCounter))+"px"
    // console.log(circlePercentage)
    document.getElementById('saveCountdownCircle').style.strokeDashoffset = circlePercentage

    // let minutes = Math.floor((maxSyncCounter - syncCounter) / 60)
    // let seconds = String((maxSyncCounter - syncCounter) % 60)
    // if (seconds.length == 1){
    //     seconds = "0" + seconds
    // }

    // document.getElementById(`saveCountdownText`).innerHTML = minutes + ":" + seconds
}

function createAccountPopup(){
    document.getElementById('popup3').style.visibility = 'visible'

    const loginBtn = document.getElementById('login')
    const launchPasswordLoginBtn = document.getElementById('launchPasswordLogin')
    let olderThanThirteen = false;
    let termsConditions = false;
    let privacyPolicy = false;

    document.getElementById('loginOlderThan13').addEventListener('change',()=>{
        olderThanThirteen = document.getElementById('loginOlderThan13').checked
        checkChecks()
    })

    document.getElementById('loginTermsConditions').addEventListener('change',()=>{
        termsConditions = document.getElementById('loginTermsConditions').checked
        checkChecks()
    })

    document.getElementById('loginPrivacyPolicy').addEventListener('change',()=>{
        privacyPolicy = document.getElementById('loginPrivacyPolicy').checked
        checkChecks()
    })

    loginBtn.addEventListener('click', () => {
        if(checkChecks()){
            signIn()
            addLoading()
            setTimeout(()=>{
                document.getElementById('popup3').style.visibility = 'visible'
            },100)
        }
    })

    launchPasswordLoginBtn.addEventListener('click', () => {
        if(checkChecks()){
            document.getElementById('popup3').style.visibility = 'hidden'
            document.getElementById('passwordLogin').style.visibility = 'visible'

            const password = document.getElementById("passwordInput")
            document.getElementById('showPassword').addEventListener('change', function() {
                if (this.checked) {
                    password.type = 'text';
                } else {
                    password.type = 'password';
                }
            });

            document.getElementById("LoginPasswordAccount").addEventListener("click",()=>{
                passwordLogin('login')
            })
            document.getElementById("CreatePasswordAccount").addEventListener("click",()=>{
                passwordLogin('create')
            })

            document.getElementById("forgotPassword").addEventListener("click",()=>{
                passwordLogin('forgot')
            })
        }
    })

    function checkChecks(){
        if(!olderThanThirteen || !termsConditions || !privacyPolicy){
            loginBtn.style.backgroundColor = "#d4d4d4";
            loginBtn.style.color = "rgb(126, 126, 126)"

            launchPasswordLoginBtn.style.backgroundColor = "#d4d4d4";
            launchPasswordLoginBtn.style.color = "rgb(126, 126, 126)"
            return false
        }else{
            loginBtn.style.backgroundColor = "cornflowerblue";
            loginBtn.style.color = "#FFFFFF"

            launchPasswordLoginBtn.style.backgroundColor = "cornflowerblue";
            launchPasswordLoginBtn.style.color = "#FFFFFF"
            return true
        }
    }

    syncData(false)
}

async function passwordLogin(action){
    const email = document.getElementById("emailInput").value;
    const password = document.getElementById("passwordInput").value;
    const loginErrorText = document.getElementById("loginErrorText")

    const loginButtons = document.querySelectorAll("#LoginPasswordAccount, #CreatePasswordAccount, #forgotPassword");
    // Disable buttons to prevent spam clicking
    loginButtons.forEach(btn => btn.disabled = true);
    
    let error = false;

    if (!validateEmail(email)) {
        loginErrorText.innerHTML = "Please provide your email.."
        return;
    }

    if(email.length == 0) {
        loginErrorText.innerHTML = 'You forgot your email..'
        return;
    }

    if(action == "forgot"){
        error = await forgotPassword(email)
    }

    else if(password.length == 0) {
        loginErrorText.innerHTML = 'Please add a password..'
        return;
    }

    if(action == "login"){
        addLoading()
        error = await signIn_EmailPassword(email, password)
    }
    if(action == "create"){
        addLoading()
        error = await create_EmailPassword(email, password)
    }

    if (error){
        removeLoading()
        if(error.code === "auth/user-not-found"){
            loginErrorText.innerHTML = 'There isnt a user with the provided login..'
        }

        else if(error.code === "auth/wrong-password"){
            loginErrorText.innerHTML = 'Incorrect Login Info'
        }

        else if(error.code === "auth/email-already-in-use"){
            loginErrorText.innerHTML = 'Somebody is already using that email..'
        }

        else if(error.code === "auth/weak-password"){
            loginErrorText.innerHTML = 'Your password is easy to guess, try something more complex.'
        }
        
        else{
            loginErrorText.innerHTML = error.message || 'An unknown error occurred.';
        }
    }else{
        if(action == "forgot"){
            removeLoading()
            const element = `
                <div class="cantClosePopup">
                    <div class="popupBox">
                        <h1 class="popupTitle">CHECK YOUR EMAIL</h1>
                        <span class="popupDescription">
                            You should recieve an email at:
                        </span>
                        <span class="popupDescription">
                            ${email}
                        </span>
                        <span class="popupDescription">
                            Click on the link in the email and follow the steps.
                        </span>
                        <span class="popupDescription">
                            After you have reset the password return here and refresh.
                        </span>
                        <span class="popupDescription">
                            Thank you!
                            <br>
                            Have fun playing!
                        </span>
                    </div>
                </div>
            `
            document.body.insertAdjacentHTML('afterbegin',element)
        }
    }

    // Re-enable buttons after a delay to prevent immediate retries
    setTimeout(() => {
        loginButtons.forEach(btn => btn.disabled = false);
    }, 1000); // 1-second cooldown
}

function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function setAccountPopUp(){

    document.getElementById('accountIcon').addEventListener('click',()=>{
        if(!signedIn){
            createAccountPopup()
        }else{
            window.location.href = "account.html"
        }
    })
}

async function changeUserName(){
    const inptElement = document.getElementById("userNameInpt")
    const newUserName = inptElement.value
    let userNameResponse = await setNewUserName(newUserName)
    if(userNameResponse == 'offensive'){
        inptElement.value = '(¬､¬)'
        setTimeout(()=>{
            inptElement.value = 'No..'
            setTimeout(()=>{
                inptElement.value = ''
            },2000)
        },2000)
    }
    else if(userNameResponse == 'long'){
        document.getElementById("userNameInpt").value = 'Max 20 Characters'
        setTimeout(()=>{
            document.getElementById("userNameInpt").value = ''
        },2000)
    }
    else{
        document.getElementById('userNamePopup').style.visibility = "hidden"
        let popupBackgrounds = document.getElementsByClassName('popup');
        for (let i = 0; i < popupBackgrounds.length; i++) {
            popupBackgrounds.item(i).addEventListener('click', handlePopupClick);
        }
        document.getElementById('userName').innerHTML = newUserName
    }
}

function setCountDownTimer(){
    const saveCountdown = document.getElementById('saveCountdown')
    saveCountdown.style.display = 'contents'
    document.getElementById('otherIcons').style.gridTemplateRows = "66px 44px 50px 50px"
    saveCountdown.addEventListener('click',()=>{
        syncCounter = 0;
        syncData(false)
        setSaveTimerText()
    })
}

function setUserHTML(){
    const userName = document.getElementById('userName')
    if(signedIn){
        userName.innerHTML = userData.userName
    
        if(userData.userName == ""){
            
            // THIS ENSURES THE USER ENTERS A USERNAME
            // Remove the event listener from each popup background
            let popupBackgrounds = document.getElementsByClassName('popup');
            for (let i = 0; i < popupBackgrounds.length; i++) {
                popupBackgrounds.item(i).removeEventListener('click', handlePopupClick);
            }
            
            document.getElementById('userNamePopup').style.visibility = 'visible'
            document.getElementById('changeUserName').addEventListener('click', ()=>{changeUserName()})
        }

        setCountDownTimer()
    }else{
        signedIn = false

        if(gameData.userName == "GUEST"){
            userName.innerHTML = "GUEST"
        }else{
            userName.innerHTML = gameData.userName
        }
    }
}

function isToday() {
    const oldData = new Date(JSON.parse(localStorage.getItem("gameData")).Date)
    const today = new Date();
    return oldData.getDate() === today.getDate() &&
           oldData.getMonth() === today.getMonth() &&
           oldData.getFullYear() === today.getFullYear();
}

let oldSyncData = {}
let oldOtherSkins = []

async function syncData(forceSync) {
    syncCounter = 0
    if (signedIn) {
        gameData.Date = Timestamp.now();  // Set date

        let highestUnlocked = 0;
        for (let i = 0; i < upgrades.length; i++) {
            if (!upgrades[i].locked) {
                highestUnlocked += 1;
            }
        }

        let newGameInfo = {
            PPS: gameData.penguinPerSecond,
            equippedSkin: gameData.currentImg,
            highestUnlocked: highestUnlocked,
            lastLogin: gameData.Date,
            gameData: { ...gameData },  // Spread to avoid mutation
            upgrades: upgrades,
            savedLeaderBoard: null
        };

        if (Object.keys(oldSyncData).length === 0) {  // Check if oldSyncData is empty
            oldSyncData = JSON.parse(JSON.stringify(newGameInfo));  // Deep copy
        } else {
            // Manually update fields we don't want to compare
            oldSyncData.lastLogin = newGameInfo.lastLogin;
            oldSyncData.gameData.Date = newGameInfo.gameData.Date;
            oldSyncData.gameData.penguins = newGameInfo.gameData.penguins;
        }

        // only checking sync if certian fields have changed
        if (!objectsAreEqualWithoutKeys(oldSyncData, newGameInfo, ['lastLogin', 'gameData.Date', 'gameData.penguins']) || forceSync) {  // Compare excluding fields

            let dataToUpdate = {};
            if (oldSyncData.PPS !== newGameInfo.PPS) {
                dataToUpdate.PPS = gameData.penguinPerSecond;
            }
            if (oldSyncData.equippedSkin !== newGameInfo.equippedSkin) {
                dataToUpdate.equippedSkin = gameData.currentImg;
            }
            if (oldSyncData.gameData.resets !== newGameInfo.gameData.resets) {
                dataToUpdate.resets = gameData.resets;
            }
            try{
                if(privateGame.otherSkins != undefined){
                    if (privateGame.otherSkins != oldOtherSkins){
                        dataToUpdate.ownedSkins = [...privateGame.otherSkins];
                        oldOtherSkins = [...privateGame.otherSkins]
                    }
                }
            }catch{

            }

            if (Object.keys(dataToUpdate).length > 0) {
                dataToUpdate.penguins = gameData.penguins
                await updateLeaderboardUserData(dataToUpdate);
            }

            oldSyncData = JSON.parse(JSON.stringify(newGameInfo));  // Deep copy
            await updateGameInfo(newGameInfo);
        }
    }
}

function objectsAreEqualWithoutKeys(obj1, obj2, excludeKeys = []) {
    const keys1 = Object.keys(obj1).filter(key => !excludeKeys.includes(key));
    const keys2 = Object.keys(obj2).filter(key => !excludeKeys.includes(key));

    // Check if both objects have the same number of keys after excluding
    if (keys1.length !== keys2.length) return false;

    for (const key of keys1) {
        if (!obj2.hasOwnProperty(key)) return false;
        if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
            // Recursively compare nested objects
            if (!objectsAreEqualWithoutKeys(obj1[key], obj2[key], excludeKeys)) return false;
        } else if (obj1[key] !== obj2[key]) {
            return false;
        }
    }
    return true;
}

let filter = {
    friends: false,
    sent: false,
    recieved: false,
}

async function createLeaderBoard(){
    const homeLeaderBoard = document.getElementById('homeLeaderBoard')
    homeLeaderBoard.innerHTML = ''

    leaderBoard.sort((a, b) => (a.resets || 0) - (b.resets || 0));

    
    let friendsAmount = 0
    let sentAmount = 0
    let recievedAmount = 0

    for(let i = 0; i < leaderBoard.length; i++){
        let imageName = leaderBoard[i].equippedSkin
        let imageURL = gameSkins[imageName] || false;

        let image;
        if (imageName == "" || !imageURL){
            image = "/images/penguins/Penguin.png"
        }else{
            image = imageURL;
        }

        const recentPlay = timeSinceLastPlay(leaderBoard[i].timeStamp).recentPlay
        let recentPlayDiv = ""
        if(recentPlay){
            recentPlayDiv = `<div class="activeDivHolder"><div class="activeDiv"></div></div>`
        }

        const name = leaderBoard[i].userName
        let resets = leaderBoard[i].resets
        if(!resets){
            resets = 0
        }

        if(!leaderBoard[i].friends){
            leaderBoard[i].friends = []
        }

        if(!leaderBoard[i].ownedSkins){
            leaderBoard[i].ownedSkins = []
        }

        let selfClass = ""
        let friend = ""
        let canAdd = true;

        if(signedIn){
            const friendId = leaderBoard[i].userId
            const userId = auth.currentUser.uid
            // ITS ME!
            if(userId && friendId == userId){
                selfClass = "selfClass"
                if(filter.sent || filter.recieved){
                    canAdd = false;
                }
            }
        
            // making sure its not me
            if(friendId != userId){
                // BOTH LISTS
                if(userData.friends.requested.includes(friendId) && leaderBoard[i].friends.includes(userId)){
                    friend = `<img src="/images/elements/friends2.png" class="friendIcon">`
                    if(filter.sent || filter.recieved){
                        canAdd = false
                    }
                    friendsAmount += 1
                }

                // MY LIST
                else if(userData.friends.requested.includes(friendId) && !leaderBoard[i].friends.includes(userId)){
                    friend = `<img src="/images/elements/friendSend.png" class="friendIcon">`
                    if(filter.recieved || filter.friends){
                        canAdd = false
                    }
                    sentAmount += 1
                }
        
                // FREIND LIST
                else if(!userData.friends.requested.includes(friendId) && leaderBoard[i].friends.includes(userId) && !userData.friends.rejected.includes(friendId)){
                    friend = `<img src="/images/elements/friendRecieve.png" class="friendIcon">`
                    if(filter.sent || filter.friends){
                        canAdd = false
                    }
                    recievedAmount += 1
                }

                else if(filter.sent || filter.friends || filter.recieved ){
                    canAdd = false
                }
    
            }
        }

        if (name != "" && !list.cheaters.includes(leaderBoard[i].userId) && canAdd){
            const sectionID = 'leaderBoardSection'+resets

            if(!document.getElementById(sectionID)){
                const leaderBoardSectionElement = `
                    <div class="leaderBoardSection" id="${sectionID}">
                        <span class="leaderBoardSectionHeader">Level - ${resets}<span>
                    </div>
                `
                homeLeaderBoard.insertAdjacentHTML('afterbegin',leaderBoardSectionElement)
            }

            const leaderBoardSection = document.getElementById(sectionID)
            const position = leaderBoardSection.children.length;
            const leaderBox = `
                <div class="leaderBoardBox ${selfClass}" data-leaderIndex="${i}">
                    <span class="leaderBoardNum">${position}</span>
                    <div class="leaderBoardImageRarity">
                        <img src="${image}" class="leaderBoardImage">
                    </div>
                    <p class="leaderBoardName">${name}</p>
                    <p class="leaderBoardPPS">PPS: ${shortenNumber(Math.round(leaderBoard[i].PPS*100))}</p>
                    ${recentPlayDiv}
                    ${friend}
                </div>
            `
            leaderBoardSection.insertAdjacentHTML('beforeend',leaderBox)
        }

        if(signedIn){
            if(friendsAmount > 0){
                document.getElementById('friendsAmount').innerHTML = friendsAmount
            }else{
                document.getElementById('friendsAmount').innerHTML = ""
            }
            if(sentAmount > 0){
                document.getElementById('sentAmount').innerHTML = sentAmount
            }else{
                document.getElementById('sentAmount').innerHTML = ""
            }
            if(recievedAmount > 0){
                document.getElementById('recievedAmount').innerHTML = recievedAmount
            }else{
                document.getElementById('recievedAmount').innerHTML = ""
            }
        }
    }

    const leaderBoardBoxes = document.getElementsByClassName('leaderBoardBox')

    if(signedIn){
        for(const leaderBoardBox of leaderBoardBoxes){
            const index = leaderBoardBox.getAttribute("data-leaderIndex")
            leaderBoardBox.addEventListener("click", ()=>{
                createPlayerPopup(index)
            })
        }
    }

    const anchor = document.getElementsByClassName('selfClass')[0];
    if (anchor) {
        // Use scrollIntoView with the smooth behavior
        const anchorPosition = anchor.offsetTop - homeLeaderBoard.offsetTop - 10;
      
        // Scroll the container to the anchor's position
        homeLeaderBoard.scrollTo({ top: anchorPosition, behavior: "smooth" });
    }
}

function addFilters(){
    if(!signedIn){
        document.getElementById("filters").style.display = "none"
        document.getElementById("homeLeaderBoard").style.height= "400px"
    }else{
        const friendsFilter = document.getElementById("friendsFilter")
        const sentFilter = document.getElementById("sentFilter")
        const recievedFilter = document.getElementById("recievedFilter")

        function removeSelect(){
            friendsFilter.classList.remove("selectedFilter")
            sentFilter.classList.remove("selectedFilter")
            recievedFilter.classList.remove("selectedFilter")
        }
    
        friendsFilter.addEventListener("click",()=>{
            filter.friends = !filter.friends
    
            filter.sent = false
            filter.recieved = false

            removeSelect()
            if(filter.friends){
                friendsFilter.classList.add("selectedFilter")
            }
            createLeaderBoard()
        })
    
        sentFilter.addEventListener("click",()=>{
            filter.sent = !filter.sent
    
            filter.friends = false
            filter.recieved = false

            removeSelect()
            if(filter.sent ){
                sentFilter.classList.add("selectedFilter")
            }
            createLeaderBoard()
        })
    
        recievedFilter.addEventListener("click",()=>{
            filter.recieved = !filter.recieved
    
            filter.sent = false
            filter.friends = false
            
            removeSelect()
            if(filter.recieved){
                recievedFilter.classList.add("selectedFilter")
            }
            createLeaderBoard()
        })
    }
}

function createPlayerPopup(index){

    let imageName = leaderBoard[index].equippedSkin
    let imageURL = gameSkins[imageName] || false;

    let image;
    if (imageName == "" || !imageURL){
        image = "/images/penguins/Penguin.png"
    }else{
        image = imageURL;
    }

    const name = leaderBoard[index].userName
    let resets = leaderBoard[index].resets
    if(!resets){
        resets = 0
    }

    let penguins = leaderBoard[index].penguins
    if(!penguins){
        penguins = "-"
    }else{
        penguins = shortenNumber(penguins)
    }
    
    const PPS = shortenNumber(Math.round(leaderBoard[index].PPS*100))
    const lastPlayed = timeSinceLastPlay(leaderBoard[index].timeStamp).time
    const friendId = leaderBoard[index].userId
    const userId = auth.currentUser.uid

    let friendBtn = ""
    let friendData = "";
    let canShowFriendData = false

    // making sure its not me
    if(userId && friendId != userId){
        // IN NEITHER LIST
        if(!userData.friends.requested.includes(friendId) && !leaderBoard[index].friends.includes(userId)){
            friendBtn =
            `   <span class="friendDescription">Friends see more data about each other's game.</span>         
                <button class="btn AddFriendBtn" id="sendFriendRequest">
                    <img src="/images/elements/friendSend.png" class="AddFriendBtnImg">
                    <span class="AddFriendBtnText">Send Friend Request</span>
                </button>
            `
        }

        // IM IN THIER LIST
        // This one is longer because it provides a way to dismiss the friend request
        if(!userData.friends.requested.includes(friendId) && leaderBoard[index].friends.includes(userId)){
            if(!userData.friends.rejected.includes(friendId)){
                friendBtn =
                `   <span class="friendDescription">Friends see more data about each other's game.</span>   
                    <button class="btn AddFriendBtn" id="sendFriendRequest">
                        <img src="/images/elements/friendRecieve.png" class="AddFriendBtnImg">
                        <span class="AddFriendBtnText">Accept Friend Request</span>
                    </button>
    
                    <button class="btn AddFriendBtn RemoveFriendBtn" id="dismissFriend">
                        <span class="AddFriendBtnText">Dismiss Friend Request</span>
                    </button>
                `
            }else{
                friendBtn =
                `   <span class="friendDescription">Friends see more data about each other's game.</span>         
                    <button class="btn AddFriendBtn" id="sendFriendRequest">
                        <img src="/images/elements/friendSend.png" class="AddFriendBtnImg">
                        <span class="AddFriendBtnText">Send Friend Request</span>
                    </button>
                `
            }
        }

        // THEY ARE IN MY LIST
        // This one calls the same code as removing
        if(userData.friends.requested.includes(friendId) && !leaderBoard[index].friends.includes(userId)){
            friendBtn =
            `  <button class="btn AddFriendBtn RemoveFriendBtn" id="removeFriend">
                    <span class="AddFriendBtnText">Unsend Friend Request</span>
                </button>
            `
        }

        // WE ARE IN EACHOTHER'S LISTS
        if(userData.friends.requested.includes(friendId) && leaderBoard[index].friends.includes(userId)){
            friendBtn =
            `            
                <button class="btn AddFriendBtn RemoveFriendBtn" id="removeFriend">
                    <span class="AddFriendBtnText">Remove Friend</span>
                </button>
            `
            canShowFriendData = true;
        }
    }else{
        canShowFriendData = true;
    }

    if(canShowFriendData){
        let skinInfo = `<span class="noSkinsYet">No Skins Yet!</span>`
        if(leaderBoard[index].ownedSkins.length > 0){
            skinInfo = ''
        }

        for(const skin of leaderBoard[index].ownedSkins){
            skinInfo += `<img src="${gameSkins[skin]}" class="leaderBoardPlayerSkin">`
        }

        friendData = 
        `   <span class="leaderBoardPlayerData"><span class="leaderBoardPlayerDataLabel">PENGUINS:</span> ${penguins}</span>
            <span class="leaderBoardPlayerData"><span class="leaderBoardPlayerDataLabel">LAST PLAYED:</span> ${lastPlayed}</span>
            <div class="leaderBoardPlayerSkins">
                ${skinInfo}
            </div>
        `
    }

    const playerPopup = `
        <div class="leaderBoardPlayerHolder">
            <div class="leaderBoardPlayerInfo">
                <div class="leaderBoardPlayerImageHolder">
                    <img src="${image}" class="leaderBoardPlayerImage">
                </div>
                <span class="leaderBoardPlayerName">${name}</span>
            </div>
            <p class="leaderBoardPlayerData"><span class="leaderBoardPlayerDataLabel">PPS:</span> ${PPS}</p>
            <span class="leaderBoardPlayerData"><span class="leaderBoardPlayerDataLabel">LEVEL:</span> ${resets}</span>
            ${friendData}
            ${friendBtn}
            <button class="btn closePopup" style="margin-top: 10px; background-color:rgb(100, 100, 100);" id="closePlayerPopup">CLOSE</button>
        </div>
    `

    const leaderBoardPlayerPopup = document.getElementById("leaderBoardPlayerPopup");
    leaderBoardPlayerPopup.innerHTML = playerPopup;
    leaderBoardPlayerPopup.style.visibility = "visible";

    const sendFriendRequest = document.getElementById("sendFriendRequest")
    const dismissFriend = document.getElementById("dismissFriend")
    const removeFriend = document.getElementById("removeFriend")

    let removeFriendClicked = false;
    let dismissFriendClicked = false;

    if(sendFriendRequest){
        sendFriendRequest.addEventListener("click",()=>{
            addFriendEvent(friendId, index)
        });
    }

    if(dismissFriend){
        dismissFriend.addEventListener("click",()=>{
            if(!dismissFriendClicked){
                dismissFriend.children[0].innerHTML = "Are you Sure?"
                dismissFriendClicked = true;
            }else{
                dismissFriendEvent(friendId, index)
            }
        });
    }

    if(removeFriend){
        removeFriend.addEventListener("click",()=>{
            if(!removeFriendClicked){
                removeFriend.children[0].innerHTML = "Are you Sure?"
                removeFriendClicked = true
            }else{
                removeFriendEvent(friendId, index)
            }
        });
    }

    document.getElementById("closePlayerPopup").addEventListener("click", ()=>{
        leaderBoardPlayerPopup.style.visibility = "hidden";
    })
}

async function addFriendEvent(friendId, leaderBoardIndex) {
    if (!userData.friends.requested.includes(friendId)) {
        userData.friends.requested.push(friendId);

        let rejectedIndex = userData.friends.rejected.indexOf(friendId);
        if (rejectedIndex !== -1) {
            userData.friends.rejected.splice(rejectedIndex, 1);
        }
        
        createPlayerPopup(leaderBoardIndex)
        createLeaderBoard()
        await setFriends(userData.friends)
    }
}

async function dismissFriendEvent(friendId, leaderBoardIndex) {
    if (!userData.friends.rejected.includes(friendId)) {
        userData.friends.rejected.push(friendId);

        createPlayerPopup(leaderBoardIndex)
        createLeaderBoard()
        await setFriends(userData.friends)
    }
}

async function removeFriendEvent(friendId, leaderBoardIndex) {
    let index = userData.friends.requested.indexOf(friendId);
    if (index !== -1) {
        userData.friends.requested.splice(index, 1);

        if (!userData.friends.rejected.includes(friendId)) {
            userData.friends.rejected.push(friendId);
        }
        
        createPlayerPopup(leaderBoardIndex)
        createLeaderBoard()
        await setFriends(userData.friends)
    }
}

async function firebaseContent(){
    skinsData = await getPenguinSkins()
    gameSkins = await loadGameSkins(skinsData)
}

async function setBackUpData(){
    try{
        let newGameData = JSON.parse(localStorage.getItem("gameData"))
        let newUpgrades = JSON.parse(localStorage.getItem("upgrades"))
        let backupSet = JSON.parse(localStorage.getItem("backupSet"))
    
        if(backupSet === null){
            if(newGameData != null){
                gameData.Date = new Date();
                localStorage.setItem('backupGameData', JSON.stringify(newGameData));
    
                // Set backupSet to true and store it in localStorage
                backupSet = true; // or false if you want it to default to false
                localStorage.setItem("backupSet", JSON.stringify(backupSet));
            }
            if(newUpgrades != null){
                localStorage.setItem('backupUpgrades', JSON.stringify(newUpgrades));
            }
        }
    }catch{
        console.log("error setting backup Data")
    }

}

function hidePopup(event) {
    if (event.target === event.currentTarget) {
        event.currentTarget.style.visibility = 'hidden';
    }
}

// Named function to attach and later remove
function handlePopupClick(event) {
    hidePopup(event);
}

// Named function to hide the parent popup
function hideParentPopup(element) {
    const popup = element.closest('.popup'); // Find the nearest parent with class 'popup'
    if (popup) {
        popup.style.visibility = 'hidden'; // Hide the parent popup
    }
}

function createNewPlayerData(){
    gameData = gameInfo.gameData
    upgrades = [{
        amount: 0,
        upgrade: 0,
        progress: 0,
        locked: true,
    }]

    gameData.userName = "GUEST"
    if(signedIn){
        setLocalStorage()
    }
}

function setPopupHiding(){
    // MAKING IT SO THAT IF YOU CLICK ON THE BACKGROUNDS THEY HIDE
    let popupBackgrounds = document.getElementsByClassName('popup');
    for (let i = 0; i < popupBackgrounds.length; i++) {
        const popup = popupBackgrounds.item(i);
    
        // Attach the background click event listener
        popup.addEventListener('click', handlePopupClick);
    
        // Attach close button listeners inside each popup
        const closeButtons = popup.getElementsByClassName('closePopup');
        for (let j = 0; j < closeButtons.length; j++) {
            closeButtons[j].addEventListener('click', (event) => {
                event.stopPropagation(); // Prevent background click from firing
                hideParentPopup(event.target); // Close the parent popup
            });
        }
    }
}

async function claimGift(){
    addLoading()
    const activateRewardResponse = await activateBirthdayReward();
    if(activateRewardResponse){
        window.location = "game.html";
    }else{
        document.getElementById("skinPopupGift").style.visibility = 'hidden';
        removeLoading()
    }
}

function createBirthdayReward(){
    document.getElementById("skinPopupGift").style.visibility = 'visible';
    document.getElementById('claimGift').addEventListener('click',()=>{
        if(signedIn){
            claimGift()
        }else{
            document.getElementById("skinPopupGift").style.visibility = 'hidden';
            createAccountPopup()
        }

    })
}

async function START(){
    setLoadingText("SETTING UP THE GAME")

    setAccountPopUp()

    addFilters()

    if(!signedIn){
        try{
            leaderBoard = await getAllUsersLeaderBoard('penguinclicker','globalPPS')
            if(leaderBoard){
                createLeaderBoard()
            }
            //document.getElementById('claimGift').innerHTML = 'LOGIN TO CLAIM'
            //createBirthdayReward()
        }catch{
            console.log("error setting up leaderboard")
        }
    }

    setPopupHiding()

    // THESE HAVE TO GO IN THIS ORDER!!
    
    if(!signedIn){
        gameData = JSON.parse(localStorage.getItem("gameData"))
        upgrades = JSON.parse(localStorage.getItem("upgrades"))

        if(!gameData){
            createNewPlayerData()
        }
    }

    if (gameData.VersionNum < 109.3){
        gameData.VersionNum = 109.3
        document.getElementById('updatePopup').style.visibility = 'visible'
    }

    if(gameData.penguinPerSecond == 0){
        newPlayer = true
        addClickNotification()
    }

    setUserHTML()

    showUpgradePoints()

    let penguin = document.getElementById("penguinImageBox")
    penguin.addEventListener("pointerdown",(e) => {
        penguin.style.transform = 'scale(1.1)'
        PenguinClicked(e)
    })
    penguin.addEventListener("pointerup",(e) => {
        penguin.style.transform = 'scale(1)'
    })
    
    let upgradeIcon = document.getElementById("upgradeIcon")
    upgradeIcon.addEventListener("click",()=>{
        document.getElementById("menu").style.visibility="visible"
        syncData(false)
    })

    // not allowing the penguin to be moved on mobile
    penguin.addEventListener('touchmove', function(event) {
        if (event.scale !== 1) {
            event.preventDefault();
        }
    }, { passive: false });
    
    // Setting all the upgrades on the screen
    for (const upgradeIndex in upgrades){
        addNewUpgradeElement(upgradeIndex)
    }

    if(upgrades.length == upgradeData.length && !upgrades[upgrades.length-1].locked && signedIn){
        addResetOption()
    }else{
        addResetPrompt(upgrades.length == upgradeData.length && !upgrades[upgrades.length-1].locked)
    }

    // Setting special Skins
    if(signedIn){
        privateGame = await getOtherSkins()
        privateUser = await getPrivateData()
        if(privateUser){
            document.getElementById('blueberries').innerText = privateUser.blueberries
            dailyReward = privateUser.dailyReward
        }
        updateLogs('sessionStart','user started play session', 'penguinClicker')

        await checkUserAgreement(userData)

        //const birthdayReward = await checkBirthdayReward()
        //if(birthdayReward){
            //createBirthdayReward()
        //}
        isEmailVerified(user)
    }

    const shownPPS = (gameData.penguinPerSecond*100).toFixed(0)

    let penguinPerSecondElement = document.getElementById("penguinsPerSecond")
    penguinPerSecondElement.innerHTML = String("PPS: "+ shownPPS)

    document.getElementById("dayNightSlider").addEventListener('click', ()=>{
        darkMode = !darkMode
        localStorage.setItem("darkMode", darkMode);
        setDayNight()
    })

    document.getElementById('upgradeBtn').addEventListener('click', () =>{
        TravelToUpgradeChest()
    })

    document.getElementById('shopBtn').addEventListener('click', () =>{
        TravelToCosmeticShop()
    })

    document.getElementById('skinsBtn').addEventListener('click', () =>{
        TravelToSkins()
    })

    // document.getElementById('communityBtn').addEventListener('click', () =>{
    //     TravelToCommunity()
    // })

    setLoadingText("ALMOST DONE")
    setMainImage()

    createActiveUpgrades()
    oldCalculatePPS()

    populateMessages()
    populateCalendar()
    
    removeLoading()
    setInterval(mainLoop, 10);
}

const calendarMap = {
    0:{
        amount: 10,
        image: "./images/elements/blueBerry.png"
    },
    1:{
        amount: 10,
        image: "./images/elements/blueBerry.png"
    },
    2:{
        amount: 10,
        image: "./images/elements/blueBerry.png"
    },
    3:{
        amount: 10,
        image: "./images/elements/blueBerry.png"
    },
    4:{
        amount: 10,
        image: "./images/elements/blueBerry.png"
    },
    5:{
        amount: 25,
        image: "./images/shopElements/blueberryPile.png"
    },
    6:{
        amount: 25,
        image: "./images/shopElements/blueberryPile.png"
    },
}

function isInCurrentWeek(dateString) {
    const [month, day, year] = dateString.split('-').map(Number);
    const inputDate = new Date(year, month - 1, day);
  
    const today = new Date();
    const currentDay = today.getDay();
    const weekStart = new Date(today);
    weekStart.setDate(today.getDate() - currentDay + (currentDay === 0 ? -6 : 1)); // Set to Monday
    weekStart.setHours(0, 0, 0, 0);
  
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6); // Set to Sunday
    weekEnd.setHours(23, 59, 59, 999);
  
    return inputDate >= weekStart && inputDate <= weekEnd;
}

function populateCalendar(){
    const calendar = document.getElementById("calendar");
    if(signedIn){
        const unclaimedDay = document.getElementById("unclaimedDay");
        const calendarPopup = document.getElementById("calendarPopup");
        const calendarPopupBox = document.getElementById("calendarPopupBox");
        calendarPopupBox.innerHTML = ''
        let unclaimedDayNotification = false;

        calendar.addEventListener("click",()=>{
            calendarPopup.style.visibility = "visible"
        })
        
        let unlocked = 0;
        let lastDayUnlocked = "";

        const today = new Date();
        const formattedDate = today.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        }).replace(/\//g, '-');

        if(dailyReward != undefined){
            unlocked = dailyReward.length
            lastDayUnlocked = dailyReward[unlocked-1]
            if(lastDayUnlocked != ""){
                if(!isInCurrentWeek(lastDayUnlocked)){
                    unlocked = 0;
                    lastDayUnlocked = "";
                    dailyReward = []
                }
            }
        }else{
            dailyReward = []
        }

        for(let i = 6; i >= 0; i--){

            let todayUnclaimed = false;
            let id = ''

            let locked = `
                <div class="calendarDayLocked">
                    <img src="./images/elements/lock.svg" class="calendarDayLockedImg">
                </div>
            `

            if(i == unlocked && !dailyReward.includes(formattedDate)){
                locked = ``
                todayUnclaimed = true;
                id = `id = "calendarDayReward"`
                unclaimedDayNotification = true
            }

            if(i < unlocked){
                locked = `
                    <div class="calendarDayLocked" style="background-color: transparent;">
                        <img src="./images/elements/check.svg" class="calendarDayLockedImg">
                    </div>
                `
            }

            const element = `
                <button class="calendarDayBtn" data-day="${i}" ${id}>
                    <span class="calendarDayName">Day ${i+1}</span>
                    <img class="calendarDayImg" src="${calendarMap[i].image}">
                    <span class="calendarDayAmount">${calendarMap[i].amount} Blueberries</span>
                    <div class="calendarBackground"></div>
                    ${locked}
                </button>
            `
            calendarPopupBox.insertAdjacentHTML('afterBegin', element);

            if(todayUnclaimed){
                const calendarDayReward = document.getElementById("calendarDayReward")
                calendarDayReward.addEventListener('click',()=>{
                    const day = calendarDayReward.getAttribute("data-day")
                    dailyReward.push(formattedDate)
                    document.getElementById('blueberries').innerText = privateUser.blueberries+calendarMap[day].amount
                    populateCalendar()
                    trigger_ClaimDailyReward()

                    const videoElement = document.createElement("video");
                    videoElement.src = "./images/other/fallingBlueberries.mp4";
                    videoElement.autoplay = true;
                    videoElement.loop = true; // Optionally loop the video
                    videoElement.muted = true; // Optionally mute the video if you don't want sound
                    videoElement.playsInline = true; // Ensures the video plays inline on mobile
                    videoElement.style.position = "absolute";
                    videoElement.style.top = "0";
                    videoElement.style.left = "0";
                    videoElement.style.width = "100%";
                    videoElement.style.height = "100%";
                    videoElement.style.pointerEvents = "none"; // Prevent any interaction with the video
                    videoElement.style.objectFit = "cover";
                    videoElement.classList.add("fadeInFadeOut")
                    calendarPopupBox.appendChild(videoElement);

                    setInterval(()=>{
                        videoElement.remove()
                    },10000)
                })
            }
        }

        calendarPopupBox.insertAdjacentHTML('afterbegin',
            `
                <p class="calendarTitle">Calendar</p>
                <p class="calendarDescription">Claim 1 each day!<br>Refreshes Sunday night.</p>
                <div class="calendarPopupBoxBackground"></div>
            `
        )

        if(unclaimedDayNotification){
            unclaimedDay.style.visibility = "visible"
        }else{
            unclaimedDay.style.visibility = "hidden"
        }
    }
    else{
        calendar.style.display = "none"
    }
}

function populateMessages(){
    const letterImgBox = document.getElementById("letterImgBox");
    const letters = document.getElementById("letters");
    if(signedIn){
        let unreadLetters = 0;
        let letterContent = ''
        document.getElementById("letterImgBox").addEventListener("click",()=>{
            letters.style.visibility = 'visible'
        })

        if(userData.letters != undefined){
            for(const i in userData.letters){
                const letter = userData.letters[i]
                let textContent = ""
                for(const text of letter.text){
                    textContent += `<li style="text-align: center;">${text}<br><br> </li>`
                }

                let buttonContent = 'Mark as Unread'
                let buttonStyle = 'background-color:  rgb(100, 100, 100);'
                if(!letter.read){
                    unreadLetters += 1
                    buttonContent = 'Mark as Read'
                    buttonStyle = ''
                }

                letterContent += `
                    <h1 class="popupTitle">${letter.header}</h1>
                    <img class="popupImage" src="${letter.image}">
                    <ul style="font-size: 20px; margin:auto; margin-left: 0px; margin-right: 30px; list-style-type: none; color: black;">${textContent}</ul>
                    <button class="btn classMarkRead" style="margin-top: 0px; ${buttonStyle}" data-index="${i}">${buttonContent}</button>
                `
            }
        }

        if(letterContent.length == 0){
            letterContent = "No Letters Yet!"
        }

        document.getElementById("letterContent").innerHTML = letterContent

        const classMarkRead = document.getElementsByClassName("classMarkRead")
        for(const btn of classMarkRead){
            btn.addEventListener("click",()=>{
                markLetter(btn)
            })
        }
        
        if(unreadLetters > 0){
            document.getElementById("unreadLetter").innerHTML = unreadLetters
            document.getElementById("unreadLetter").style.visibility = "visible"
        }else{
            document.getElementById("unreadLetter").style.visibility = "hidden"
        }
    }
    else{
        letterImgBox.style.display = "none"
    }
}

async function markLetter(btn){
    const index = btn.getAttribute('data-index')
    userData.letters[index].read = !userData.letters[index].read

    if(userData.letters[index].read){
        btn.innerHTML = 'Mark as Unread'
        btn.style.backgroundColor = "rgb(100, 100, 100)";
    }else{
        btn.innerHTML = 'Mark as Read'
        btn.style.backgroundColor = "cornflowerblue";
    }

    let unreadLetters = 0;

    for(const letter of userData.letters){
        if(!letter.read){
            unreadLetters += 1
        }
    }

    if(unreadLetters > 0){
        document.getElementById("unreadLetter").innerHTML = unreadLetters
        document.getElementById("unreadLetter").style.visibility = "visible"
    }else{
        document.getElementById("unreadLetter").style.visibility = "hidden"
    }

    await setLetters(userData.letters)
}

async function TravelToCosmeticShop(){
    await syncData(false)
    window.location.href = './shop/shop.html'
}

async function TravelToUpgradeChest(){
    await syncData(false)
    window.location.href = './upgradeShop.html'
}

async function TravelToSkins(){
    await syncData(false)
    window.location.href = './skins/skins.html'
}

async function TravelToCommunity(){
    await syncData(false)
    window.location.href = './community/community.html'
}

// DOM
async function useLocalStorage(localGameData, localupgrades) {
    try {
        gameData = localGameData;
        upgrades = localupgrades;

        // Check if user data is corrupted
        if (!checkUserDataForCorruption()) {
            setLoadingText("FOUND CORRUPTED DATA")
            localStorage.removeItem("backupGameData");
            localStorage.removeItem("backupUpgrades");
            localStorage.removeItem("backupSet");
            createNewPlayerData();  // Reset the player data if corrupted
            CHECKUSER()
        } else {
            await syncData(true).then((response) => {
                removeRefresh(); // If you need to remove refresh, do it here
            });
        }
    } catch (error) {
        console.error("Error in useLocalStorage:", error);
        // Handle potential errors, like corrupted data parsing
        removeRefresh();  // Uncomment if needed
    }
}

function checkUserDataForCorruption() {
    const gameDataKeys = Object.keys(gameData);  // Get keys of gameData

    // Check if all keys in gameInfo.gameData exist in gameData and have the same types
    for (const key in gameInfo.gameData) {
        if (!gameDataKeys.includes(key) || gameData[key] === null || typeof gameData[key] !== typeof gameInfo.gameData[key]) {
            console.error(`Corruption detected in gameData key: ${key}`);
            return false;
        }
    }

    // Validate upgrades array
    for (let i = 0; i < upgrades.length; i++) {
        if (typeof upgrades[i].amount !== "number" || typeof upgrades[i].upgrade !== "number" || 
            typeof upgrades[i].progress !== "number" || typeof upgrades[i].locked !== "boolean") {
            console.error(`Corruption detected in upgrades array at index: ${i}`);
            return false;
        }
    }

    return true;  // If no corruption is found, return true
}

async function removeRefresh(){
    localStorage.removeItem("upgrades");
    localStorage.removeItem("gameData");
    CHECKUSER()
}

function createDataChoicePopup() {
    document.getElementById('dataChoicePopup').style.visibility = 'visible';
    const localGameData = JSON.parse(localStorage.getItem("gameData"));

    let image;

    try {
        // Try to get the local skin URL
        // PROBLEM
        let localSkinData = gameSkins[gameData.currentImg] || false;
        let localSkinURL = localSkinData ? localSkinData : false;

        if (!localSkinURL) {
            image = "/images/penguins/Penguin.png";  // Fallback image
        } else {
            image = localSkinURL;
        }
    } catch (error) {
        console.error("Error accessing local skin data:", error);
        image = "/images/penguins/Penguin.png";  // Fallback image
    }

    const localElement = `
        <div class="gameDataBox" id="localStorage">
            <img src="${image}" class="gameDataImage">
            <p class="gameDataName">${localGameData?.userName || 'Unknown'}</p>
            <p class="gameDataPPS">PPS: ${Math.round(localGameData?.penguinPerSecond * 100 || 0)}</p>
        </div>
    `;

    try {
        // Try to get the online skin URL
        // PROBLEM
        let onlineSkinData = gameSkins[gameData.currentImg] || false;
        let onlineSkinURL = onlineSkinData ? onlineSkinData : false;

        if (!onlineSkinURL) {
            image = "/images/penguins/Penguin.png";  // Fallback image
        } else {
            image = onlineSkinURL;
        }
    } catch (error) {
        console.error("Error accessing online skin data:", error);
        image = "/images/penguins/Penguin.png";  // Fallback image
    }

    const cloudElement = `
        <div class="gameDataBox" id="cloudStorage">
            <img src="${image}" class="gameDataImage">
            <p class="gameDataName">${userData?.userName || 'Unknown'}</p>
            <p class="gameDataPPS">PPS: ${Math.round(userGameData?.PPS * 100 || 0)}</p>
        </div>
    `;

    document.getElementById('gameSaves').insertAdjacentHTML('afterend', localElement + cloudElement);

    document.getElementById('localStorage').addEventListener('click', () => {
        document.getElementById('dataChoicePopup').style.visibility = 'hidden';
        const localupgrades = JSON.parse(localStorage.getItem("upgrades"));
        useLocalStorage(localGameData,localupgrades);
    });

    document.getElementById('cloudStorage').addEventListener('click', () => {
        document.getElementById('dataChoicePopup').style.visibility = 'hidden';
        removeRefresh();
    });
}

let darkMode = false

function setDayNight(){
    const dayNightSlider = document.getElementById("dayNightSlider")
    const dayNightDot = document.getElementById("dayNightDot")
    const dayNightImage = document.getElementById("dayNightImage")
    const loadingBox = document.getElementById("loadingBox")
    const reportIssue = document.getElementById("loadingError")

    if(darkMode){
        dayNightSlider.classList.remove('nightSlider')
        dayNightSlider.classList.add('daySlider')

        dayNightDot.classList.remove('nightDot')
        dayNightDot.classList.add('dayDot')

        dayNightImage.src = '/images/elements/sun.svg'
        dayNightSlider.style.backgroundImage = 'url("/images/elements/DaySlider.png")'
        
        document.body.style.backgroundColor = "#EEEEEE"
        document.body.style.color = "#000000"
        if(loadingBox){
            loadingBox.style.backgroundColor = "#EEEEEE"
            loadingBox.style.color = "#000000"
            reportIssue.style.color = "#000000"
        }

        
    }else{
        dayNightSlider.classList.add('nightSlider')
        dayNightSlider.classList.remove('daySlider')

        dayNightDot.classList.add('nightDot')
        dayNightDot.classList.remove('dayDot')

        dayNightImage.src = '/images/elements/moon.svg'
        dayNightSlider.style.backgroundImage = 'url("/images/elements/NightSlider.png")'

        document.body.style.backgroundColor = "rgb(53, 53, 53)"
        document.body.style.color = "rgb(255, 187, 0)"
        if(loadingBox){
            loadingBox.style.backgroundColor = "rgb(53, 53, 53)"
            loadingBox.style.color = "rgb(255, 187, 0)"
            reportIssue.style.color = "rgb(255, 187, 0)"
        }
    }
}


async function CHECKUSER(){
    attempts += 1
    if(attempts < maxAttempts){
        if(user){
            signedIn = true
        }

        list = await getLists()
        if(signedIn && list.cheaters.includes(auth.currentUser.uid)){
            document.getElementById("CongratsYouWon").style.visibility = 'visible'
            removeLoading()
            document.getElementById('accountButton').addEventListener('click', ()=>{
                window.location.href = "account.html"
            })
        }else if(signedIn){
            setLoadingText("LOGIN SUCCESS")
            let data = await getUserInfo('penguinclicker')

            setLoadingText("SETTING USER LOGIN DATA")
            await updateUserLoginTime()
            if(data == undefined){
                setLoadingText("SETTING UP NEW ACCOUNT...")
                setTimeout(()=>{
                    setLoadingText("ONE MORE SEC...")
                    setTimeout(()=>{
                        INIT()
                    },2500)
                },2500)
            }else{
                userData = data[0]
                userGameData = data[1]
                userPublic = data[2]

                // Friends is not correct
                if (!userData.friends || typeof userData.friends !== "object" || Array.isArray(userData.friends)) {
                    userData.friends = {
                        requested: [],
                        rejected: [],
                    };
                }

                if(userGameData.gameData){
                    const localGameData = JSON.parse(localStorage.getItem("gameData"))
                    if(localGameData && localGameData.penguinPerSecond > 0){
                        setLoadingText("FOUND CONFLICTING DATA")
                        createDataChoicePopup()
                    }
                    else if(localGameData && localGameData.penguinPerSecond == 0){
                        removeRefresh()
                    }
                    else{
                        setLoadingText("FOUND GAME DATA")
                        gameData = userGameData.gameData
                        upgrades = userGameData.upgrades
                        
                        const dataToUpdate = {
                            "PPS": gameData.penguinPerSecond,
                            "equippedSkin": gameData.currentImg,
                            "id": userData.id,
                            "userName": userData.userName,
                            "resets" : gameData.resets
                        }

                        await updateLeaderboardUserData(dataToUpdate)
                        leaderBoard = await getAllUsersLeaderBoard('penguinclicker','globalPPS')

                        await createLeaderBoard()
                        getTimePassed()
                        START()
                    }
                }else{
                    setLoadingText("SETTING UP NEW USER");
                    try {
                        
                        const localGameData = JSON.parse(localStorage.getItem("gameData"));
                        const backupGameData = JSON.parse(localStorage.getItem("backupGameData"));
                        
                        // Check if localGameData is null
                        if (localGameData === null && backupGameData === null) {
                            // If it's null, create new player data or handle the case accordingly
                            createNewPlayerData();
                            useLocalStorage(gameData, upgrades);
                        } 
                        
                        else if(localGameData != null){
                            // Use local storage data if it's not null
                            const localupgrades = JSON.parse(localStorage.getItem("upgrades"))
                            useLocalStorage(localGameData, localupgrades);
                        } 
                        
                        else if(backupGameData != null){
                            const backupUpgrades = JSON.parse(localStorage.getItem("backupUpgrades"))
                            useLocalStorage(backupGameData, backupUpgrades);
                        }

                    } catch (error) {
                        // Handle any errors, such as invalid JSON
                        console.error("Error parsing gameData:", error);
                        // removeRefresh() if needed
                        removeRefresh();
                    }
                }
            }
        }else{
            setLoadingText("NO USER FOUND")
            START()
        }
    }else{
        setLoadingText("ERROR - PLEASE CONTACT ME OVER DISCORD")
    }
}

function getGameInfo(){
    // these are stagnat data
    upgradeData = gameInfo.upgradeData
    upgradeRewardTypes = gameInfo.upgradeRewardTypes
}

async function initDarkMode(){
    darkMode = JSON.parse(localStorage.getItem("darkMode"))
    if(darkMode == null){
        // Check to see if Media-Queries are supported
        if (window.matchMedia) {
            // Check if the dark-mode Media-Query matches
            if(window.matchMedia('(prefers-color-scheme: dark)').matches){
                darkMode = true
            } else {
                darkMode = false
            }
        }
    }

    setDayNight()
}

async function INIT(){
    await initDarkMode()
    // GETTING SKINS
    await firebaseContent()

    getGameInfo()

    // BACKUP
    setBackUpData()

    auth.onAuthStateChanged((newUser) => {
        user = newUser
        setLoadingText("LOGING IN")
        CHECKUSER()
    });
}

window.addEventListener("load", () => {
    INIT()
});

function printMousePos(event) {
    const clickEffect = document.createElement("div");

    clickEffect.classList.add("ClickEffect")
    clickEffect.style.left = String((event.clientX + window.pageXOffset)+'px')
    clickEffect.style.top = String((event.clientY + window.pageYOffset)+'px')

    document.body.appendChild(clickEffect);

    setTimeout(()=>{
        clickEffect.remove();
    }, 200) 
}

// Target all clicks on any element
document.addEventListener('click',(e) =>
  {
    printMousePos(e)
    
    // Get element class(es)
    let elementClass = e.target.className;
    // If element has class(es)
    if (elementClass == 'upgrade') {
        upgradeClicked(e.target.id)
    }

    if (elementClass == 'fishImage') {
        fishClicked(e)
    }
  }
);

// triggered when returning
document.addEventListener("visibilitychange", function() {
    if (!document.hidden){
        getTimePassed()
    }
});

// LOCALSTORAGE
function checkForUpdate(newGameData, NewUpgrades){

    // ADDING NEW GAME DATA VARIABLE
    const gameDataKeys = Object.keys(gameData)
    for (let i = 0; i < gameDataKeys.length; i++){
        if (!Object.keys(newGameData).includes(gameDataKeys[i])){
            newGameData[gameDataKeys[i]] = gameData[gameDataKeys[i]]
        }
    }

    // ADDING NEW KEY TO INIDIVIDUAL UPGRADES
    const upgradesKeys = (Object.keys(Object.values(upgrades)[0]))
    const NewUpgradesValues = (Object.keys(upgrades))
    for (let i = 0; i < upgradesKeys.length; i++){
        if (!Object.keys(Object.values(NewUpgrades)[0]).includes(upgradesKeys[i])){
            const newKey = upgradesKeys[i]
            const newValue = Object.values(upgrades)[0][newKey]
            for (let j = 0; j < NewUpgradesValues.length; j++){
                Object.values(NewUpgrades)[j][newKey] = newValue
            }
        }
    }
}

async function setMainImage(){
    var canvas = document.getElementById('penguinImageBox'),
    ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    let image = gameSkins[gameData.currentImg]
    if(!image){
        image = "./images/penguins/Penguin.png"
    }

    // Set canvas size for HiDPI screens
    const scaleFactor = window.devicePixelRatio || 1;
    canvas.width = 250 * scaleFactor;
    canvas.height = 250 * scaleFactor;
    canvas.style.width = '250px';
    canvas.style.height = '250px';
    ctx.scale(scaleFactor, scaleFactor);

    // Create an Image object
    const img = new Image();

    // Set the image source
    img.src = image; // Replace with the path to your image file

    // Wait for the image to load, then draw it on the canvas
    img.onload = function() {
        // Calculate scaled dimensions to fit within the canvas
        const aspectRatio = img.width / img.height;
        let drawWidth = canvas.width / scaleFactor;
        let drawHeight = canvas.height / scaleFactor;
    
        if (aspectRatio > 1) {
            // Image is wider than tall
            drawHeight = drawWidth / aspectRatio;
        } else {
            // Image is taller than wide
            drawWidth = drawHeight * aspectRatio;
        }
    
        // Center the image on the canvas
        const x = (canvas.width / scaleFactor - drawWidth) / 2;
        const y = (canvas.height / scaleFactor - drawHeight) / 2;
    
        // Draw the scaled image on the canvas
        ctx.drawImage(img, x, y, drawWidth, drawHeight);
    };
     
    // WHEN GOLD FISH REWARDED
    if(signedIn){
        syncData(false)
    }
}

function setLocalStorage(){
    gameData.Date = new Date();
    localStorage.setItem('gameData', JSON.stringify(gameData));
    localStorage.setItem('upgrades', JSON.stringify(upgrades));
}

// OTHER GENERAL FUNCTIONS

function getRandomInt(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled)
}

function shortenNumber(number){

    // K
    if (number >= 10000 && number < 100000){
        return String((number/1000).toFixed(3)+" K")
    }
    else if (number >= 100000 && number < 1000000){
        return String((number/1000).toFixed(2)+" K")
    }

    // M
    else if (number >= 1000000 && number < 10000000){
        return String((number/1000000).toFixed(4)+" M")
    }
    else if (number >= 10000000 && number < 100000000){
        return String((number/1000000).toFixed(3)+" M")
    }
    else if (number >= 100000000 && number < 1000000000){
        return String((number/1000000).toFixed(2)+" M")
    }

    // B
    else if (number >= 1000000000 && number < 10000000000){
        return String((number/1000000000).toFixed(4)+" B")
    }
    else if (number >= 10000000000 && number < 100000000000){
        return String((number/1000000000).toFixed(3)+" B")
    }
    else if (number >= 100000000000 && number < 1000000000000){
        return String((number/1000000000).toFixed(2)+" B")
    }

    // T
    else if (number >= 1000000000000 && number < 10000000000000){
        return String((number/1000000000000).toFixed(4)+" T")
    }
    else if (number >= 10000000000000 && number < 100000000000000){
        return String((number/1000000000000).toFixed(3)+" T")
    }
    else if (number >= 100000000000000){
        return String((number/1000000000000).toFixed(2)+" T")
    }

    else{
        return(String(number))
    }
}

// NEW STUFF ORGANIZE THIS

function showUpgradePoints(){
    const upgradeElement = document.getElementById("upgradePointNumber")
    if(upgradeElement && gameData.upgradePoints > 0){
        upgradeElement.innerHTML = gameData.upgradePoints
    }
    else if(upgradeElement && gameData.upgradePoints <= 0){
        upgradeElement.remove()
    }
    else if(!upgradeElement && gameData.upgradePoints > 0){
        document.getElementById("upgradeIcon").insertAdjacentHTML("beforeend",
        `
            <div class="iconNum">0</div>
        `)

        document.getElementById("upgradeBtn").insertAdjacentHTML("beforeend",
        `
            <div class="iconNum buttonIconNum">0</div>
        `)

        let iconNums = document.getElementsByClassName('iconNum');
        for (let i= 0; i < iconNums.length; i++){
            iconNums.item(i).innerHTML = gameData.upgradePoints;
        }
    }

    document.getElementById('penguinCoins').innerHTML = gameData.upgradePoints;
}

function createActiveUpgrades(){
    let activatedPenguins = ``
    for (const activeupgrade in gameData.activeUpgrades){
        const name = gameData.activeUpgrades[activeupgrade].name
        if(gameData.activeUpgrades[activeupgrade].type != "penguin"){
            const newUpgrade = `
            <div class="upgradeCountdown" id="${gameData.activeUpgrades[activeupgrade].id}">
                <img class="activeUpgrade" src="./images/upgradeIcons/${name}.png">
                <svg>
                <circle r="30" cx="32" cy="32" id="${gameData.activeUpgrades[activeupgrade].id}Circle"></circle>
                </svg>
                <text id="${gameData.activeUpgrades[activeupgrade].id}TimeText" >${gameData.activeUpgrades[activeupgrade].timeRemaining}</text>
            </div>
            `
            document.getElementById("activeUpgrades").insertAdjacentHTML("beforeend", newUpgrade);
        }else{
            upgradeActivated(name, true)
            gameData.activeUpgrades.splice(activeupgrade,1)

            let centeredPenguinImg = ''
            if(activatedPenguins.length == 0){
                activatedPenguins += `
                    <h1 class="popupTitleWelcome">ACTIVATED PENGUINS!</h1>
                `
                centeredPenguinImg = 'centeredPenguinImg'
            }

            let imageName = upgradeData[name].type
            const image = gameSkins[imageName]
            activatedPenguins += `
                <img src="${image}" class="activatedPenguinImg ${centeredPenguinImg}">
            `
        }
    }
    if(activatedPenguins.length > 0){
        document.getElementById("activatedPenguinsBox").insertAdjacentHTML('afterbegin', activatedPenguins);
        document.getElementById("activatedPenguins").style.visibility = "visible";
    }

    updateActiveUpgrades()
}

function updateActiveUpgrades(){

    // Setting here so that its not compounding
    clickRewardMultiplier = 0
    multiplyRewardMultiplier = 1
    fishChance = 1
    fishMaxCounter = 2000

    let clickRewardsActive = 0
    let multiplyRewardsActive = 0
    let moreFishRewardsActive = 0
    let removedElements = []

    for (const activeupgrade in gameData.activeUpgrades){
        if(gameData.activeUpgrades[activeupgrade].type != "penguin"){

            gameData.activeUpgrades[activeupgrade].timeElapsed += 1
            const duration = upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].duration;

            const foundElement = document.getElementById(`${gameData.activeUpgrades[activeupgrade].id}`)
    
            if(gameData.activeUpgrades[activeupgrade].timeElapsed <= duration && foundElement){
    
                const circlePercentage = String((((gameData.activeUpgrades[activeupgrade].timeElapsed)*190)/duration))+"px"
                document.getElementById(`${gameData.activeUpgrades[activeupgrade].id}Circle`).style.strokeDashoffset = circlePercentage
    
                let minutes = Math.floor((duration - gameData.activeUpgrades[activeupgrade].timeElapsed) / 60)
                let seconds = String((duration - gameData.activeUpgrades[activeupgrade].timeElapsed) % 60)
                if (seconds.length == 1){
                    seconds = "0" + seconds
                }
    
                document.getElementById(`${gameData.activeUpgrades[activeupgrade].id}TimeText`).innerHTML = minutes + ":" + seconds
    
                if(upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].type == "click"){
                    clickRewardMultiplier += Math.ceil(((gameData.penguinPerSecond*100) / upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].clickPercentage))
                    if(clickRewardMultiplier == 0){
                        clickRewardMultiplier = 1
                    }
                    clickRewardsActive += 1
                }
    
                if(upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].type == "multiply"){
                    multiplyRewardMultiplier += upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].multiply
                    multiplyRewardsActive += 1
                }

                if(upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].type == "moreFish"){
                    fishChance += upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].randAdd
                    fishMaxCounter -= upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].subtract
                    moreFishRewardsActive += 1
                }
    
            }else if(foundElement){
                // This needs to go last
                removedElements.push(gameData.activeUpgrades[activeupgrade].id)
            }
        }
    }

    // Removing Elements from array outside of the loop
    for (const activeupgrade in gameData.activeUpgrades){
        if (removedElements.includes(gameData.activeUpgrades[activeupgrade].id)){
            document.getElementById(`${gameData.activeUpgrades[activeupgrade].id}`).remove()   

            if(upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].type == "click"){ 
                clickRewardMultiplier -= Math.floor(((gameData.penguinPerSecond*100) / upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].clickPercentage))
            }

            if(upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].type == "multiply"){
                multiplyRewardMultiplier -= upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].multiply
            }

            if(upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].type == "moreFish"){
                fishChance -= upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].randAdd
                fishMaxCounter += upgradeRewardTypes[gameData.activeUpgrades[activeupgrade].name].subtract
            }

            gameData.activeUpgrades.splice(activeupgrade,1);
            // WHEN EACH MULTIPLIER FINISHES
        }
    }

    // Reseting All Variables
    if (clickRewardsActive == 0){
        clickRewardMultiplier = 0
    }

    if (multiplyRewardsActive == 0){
        multiplyRewardMultiplier = 1
        document.getElementById("multiplyerNumber").style.visibility = "hidden"
    }else{
        document.getElementById("multiplyerNumber").style.visibility = "visible"
        document.getElementById("multiplyerNumber").innerHTML = "X"+ (multiplyRewardMultiplier-1)
    }

    if (moreFishRewardsActive == 0){
        fishChance = 1
        fishMaxCounter = 2000
    }

}